import React, { useState, useEffect } from 'react';
import { subscribeToSettings } from '../admin/services/settingsService';
import Maintenance from './Maintenance';
import { Link } from 'react-router-dom';
import '../App.css';

const SocialIcon = ({ platform }) => {
  const icons = {
    facebook: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
    ),
    twitter: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.84 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/></svg>
    ),
    instagram: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
    ),
    youtube: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505a3.017 3.017 0 00-2.122 2.136C0 8.055 0 12 0 12s0 3.945.501 5.814a3.017 3.017 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.945 24 12 24 12s0-3.945-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
    ),
    linkedin: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z"/></svg>
    ),
    github: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/></svg>
    ),
    tiktok: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.9-.32-1.92-.35-2.81-.07-.75.24-1.41.69-1.84 1.34s-.62 1.45-.58 2.22c.04.59.21 1.19.53 1.7.54.81 1.44 1.39 2.39 1.5.76.08 1.54-.11 2.19-.51.84-.45 1.42-1.3 1.61-2.22.05-.33.05-.66.04-.99.02-4.02.01-8.04.02-12.06z"/></svg>
    ),
    link: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"></path></svg>
    )
  };

  return icons[platform] || icons.link;
};

const colors = [
  { name: 'Black', hex: '#000000', label: 'Make my screen black' },
  { name: 'White', hex: '#ffffff', label: 'Make my screen white' },
  { name: 'Green', hex: '#059669', label: 'Make my screen green' },
  { name: 'Blue', hex: '#2563eb', label: 'Make my screen blue' },
  { name: 'Red', hex: '#dc2626', label: 'Make my screen red' },
  { name: 'Purple', hex: '#7c3aed', label: 'Make my screen purple' },
];

const reasons = [
  { title: 'Save energy', description: 'Making your screen all black saves energy. This is especially true on OLED screens, where black pixels actually turn off.' },
  { title: 'As a prank', description: 'You can use this as a prank to pretend that the device is dead.' },
  { title: 'Check for dead pixels', description: 'A completely black screen makes it easier to spot dead pixels.' },
  { title: 'Stealth mode', description: "When you're in a dark room and you want to temporarily switch off the display light, this can be easier than putting your device into standby mode." },
  { title: 'Meditation', description: 'You can use this to meditate. Feel free to play your favorite meditation long while you heat it.' },
  { title: 'Better than standby mode', description: 'You get most of the benefits of being in standby mode, with your apps still running in the background.' },
  { title: 'Check if screen is OLED', description: 'You can use this to check if you actually have an OLED screen, as OLED screens dont emit light when set to black.' },
  { title: 'Use screen as mirror', description: 'Need to see who is behind you? A black screen can help you see reflections. Works better on glossy displays.' },
  { title: 'See the dust', description: 'Need to clean your screen, but dont want to turn it off? This will help you see all those dust particles.' },
  { title: 'Because it\'s cool', description: 'Instead of your music player or just let the stay stylish, black will never go out of fashion.' },
];

const faqs = [
  { question: 'Does it work on iOS devices?', answer: 'Yes. Online using a web browser, since iOS does not support native browser fullscreen.' },
  { question: 'Does it work with multiple screens?', answer: 'Yes.' },
  { question: 'Does it prevent standby mode?', answer: 'Yes, most browsers prevent the device from entering into standby when a video runs.' },
  { question: 'Does it work with multiple colors?', answer: 'Yes, feel free to choose any of the colors available.' },
  { question: 'Why make my screen all black?', answer: 'There are several reasons why you might want to make your screen black. Check the section above for some common examples.' },
  { question: 'I like this tool. How can I say thanks?', answer: 'Bookmark this page for later use and share it on social media to help it reach as many people as possible.' },
  { question: 'How does this work?', answer: 'It uses some very basic Javascript. The method is called requestFullscreen(). Works with most browsers, including iOS ones.' },
];

function Home() {
  const [activeColor, setActiveColor] = useState(null);
  const [showReminder, setShowReminder] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const [settings, setSettings] = useState({ title: 'ALL BLACK SCREEN', maintenanceMode: false });
  const [loadingSettings, setLoadingSettings] = useState(true);

  useEffect(() => {
    // Timeout to make sure loading screen dismisses even if firestore rules block
    const timeoutId = setTimeout(() => {
      setLoadingSettings(false);
    }, 5000);

    const unsub = subscribeToSettings((data) => {
      clearTimeout(timeoutId);
      setSettings(data || { title: 'ALL BLACK SCREEN', maintenanceMode: false });
      if (data && data.title) {
        document.title = data.title;
      }
      setLoadingSettings(false);
    });
    return () => {
      clearTimeout(timeoutId);
      if (unsub) unsub();
    };
  }, []);

  useEffect(() => {
    if (settings.headerScripts) {
      // Remove any previously injected elements
      const existingInjected = document.querySelectorAll('[data-injected="true"]');
      existingInjected.forEach(el => el.remove());

      // Create a temporary container to parse the HTML string
      const parser = new DOMParser();
      const doc = parser.parseFromString(settings.headerScripts, 'text/html');
      const nodes = Array.from(doc.head.childNodes).concat(Array.from(doc.body.childNodes));
      
      nodes.forEach(node => {
        if (node.nodeName === 'SCRIPT') {
          const script = document.createElement('script');
          // Copy attributes
          Array.from(node.attributes).forEach(attr => script.setAttribute(attr.name, attr.value));
          // Copy content
          script.text = node.innerHTML;
          script.setAttribute('data-injected', 'true');
          document.head.appendChild(script);
        } else if (node.nodeType === 1) { // ELEMENT_NODE
          const el = node.cloneNode(true);
          el.setAttribute('data-injected', 'true');
          document.head.appendChild(el);
        }
      });
    }
  }, [settings.headerScripts]);

  useEffect(() => {
    const handleFullScreenChange = () => {
      if (!document.fullscreenElement) {
        setActiveColor(null);
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        exitFullScreen();
      }
    };

    document.addEventListener('fullscreenchange', handleFullScreenChange);
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const enterFullScreen = (color) => {
    setActiveColor(color);
    setShowReminder(true);
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen().catch(() => {
        // Fallback for browsers that block auto-fullscreen
      });
    }
    setTimeout(() => setShowReminder(false), 3000);
  };

  const exitFullScreen = () => {
    setActiveColor(null);
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => { });
    }
  };

  if (loadingSettings) {
    return <div className="min-h-screen bg-white" />; // Optional completely blank loader
  }

  if (settings.maintenanceMode) {
    return <Maintenance />;
  }

  return (
    <div className="min-h-screen pb-20">
      {/* Fullscreen Overlay */}
      {activeColor && (
        <div
          className="fixed inset-0 z-50 cursor-none flex items-center justify-center"
          style={{ backgroundColor: activeColor }}
          onClick={exitFullScreen}
        >
          {showReminder && (
            <div className="exit-reminder">
              Press ESC to exit
            </div>
          )}
        </div>
      )}

      {/* Header */}
      <header className="pt-20 pb-16 text-center animate-fade-in">
        <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-4 uppercase">
          {settings.title}
        </h1>
        <p className="text-xl text-slate-500 font-medium">
          Make your screen black.
        </p>
      </header>

      {/* Color Grid */}
      <main className="max-w-4xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8 mb-32">
        {colors.map((color, index) => (
          <div
            key={color.name}
            className="premium-card p-6 flex items-center space-x-6 cursor-pointer group"
            onClick={() => enterFullScreen(color.hex)}
            style={{ animationDelay: `${index * 100}ms` }}
          >
            <div
              className="w-32 h-20 rounded-xl shadow-inner border border-black/5 flex-shrink-0 transition-transform group-hover:scale-105"
              style={{ backgroundColor: color.hex === '#ffffff' ? '#f8fafc' : color.hex, borderColor: color.hex === '#ffffff' ? '#e2e8f0' : 'transparent' }}
            />
            <div className="flex-grow">
              <h3 className="text-xl font-bold mb-1">{color.label}</h3>
              <p className="text-slate-400 text-sm">Click to enter full screen</p>
            </div>
          </div>
        ))}
      </main>

      {/* Why Section */}
      <section className="bg-white py-24 mb-32 border-y border-slate-100">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-16">Why make my screen black</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            {reasons.map((reason, index) => (
              <div key={index} className="space-y-3">
                <h3 className="text-xl font-bold text-slate-900 leading-tight">
                  {reason.title}
                </h3>
                <p className="text-slate-500 leading-relaxed text-sm">
                  {reason.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="max-w-3xl mx-auto px-6 mb-32">
        <h2 className="text-4xl font-bold text-center mb-16">Frequently asked questions</h2>
        <div className="divide-y divide-slate-100">
          {faqs.map((faq, index) => (
            <div key={index} className="py-6">
              <button
                className="w-full text-left flex justify-between items-center group"
                onClick={() => setOpenFaq(openFaq === index ? null : index)}
              >
                <span className="text-lg font-semibold text-slate-800 group-hover:text-accent transition-colors">
                  {faq.question}
                </span>
                <span className={`transform transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`}>
                  <svg className="w-5 h-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </span>
              </button>
              <div className={`mt-4 overflow-hidden transition-all duration-300 ${openFaq === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                <p className="text-slate-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="text-center py-12 border-t border-slate-100">
        <div className="flex justify-center space-x-6 mb-8">
          {settings.socialLinks?.map((link) => (
            <a 
              key={link.id} 
              href={link.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-slate-400 hover:text-slate-900 transition-all hover:-translate-y-1"
              title={link.platform}
            >
              <SocialIcon platform={link.platform} />
            </a>
          ))}
        </div>

        <div className="flex justify-center space-x-6 mb-4">
          <Link to="/blog" className="text-sm text-slate-500 hover:text-slate-900 transition-colors">Blog</Link>
          <a href="/sitemap.xml" className="text-sm text-slate-500 hover:text-slate-900 transition-colors">Sitemap</a>
          <a href="/robots.txt" className="text-sm text-slate-500 hover:text-slate-900 transition-colors">Robots.txt</a>
        </div>
        <p className="text-slate-400 text-sm">
          © {new Date().getFullYear()} {settings.title}. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default Home;
